module.exports = __webpack_public_path__ + "static/media/2.f6fe8afb.svg";